<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer003">
<h2 class="fm_head" id="_idParaDest-1"><a id="_idTextAnchor000"></a><a href="#/text/9780062917492_Contents#r_idParaDest-1"><span class="right_1" epub:type="pagebreak" id="page_iii" title="iii">Dedication</span></a></h2>
<p class="ded_txt"><i>For Chus, with all my love</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062917492_Dedication.vue?06431252